import {Injectable, Injector} from "@angular/core";
import {EntityModel} from "@fedeltapointofsale/data-client";
import {BIPageData} from "./bi-page.data";

@Injectable()
export class BIPageEntityModel extends EntityModel<BIPageData> {
    constructor(injector: Injector) {
        super(injector, BIPageData);
    }
}
